import "./DataForm.css";
import React, { useState, useEffect } from "react";
import {
  InputWrapper,
  Input,
  Button,
  Container,
  RadioGroup,
  Radio,
} from "@mantine/core";
import { FaPercentage } from "react-icons/fa";
import { useNotifications } from "@mantine/notifications";

export default function DataForm() {
  const notifications = useNotifications();
  const [disableEPS, setdisableEPS] = useState(false);
  const [inputParams, setinputParams] = useState({
    EPS: "1",
    PayoutRation: "100",
    g: "100",
    gn: "100",
    r: "100",
    N: "1",
    PayoutRationWithN: "100",
  });
  const [realResult, setrealResult] = useState(0);
  const [result, setResult] = useState(0);
  const handleValue = (e) => {
    setinputParams((inputParams) => ({
      ...inputParams,
      [e.target.name]: e.target.value,
    }));
  };
  useEffect(() => {
    return () => {
      notifications.showNotification({
        title: "Welcome to PE calculator",
        message: "Input values and press calculate to get the result",
        color: "red",
      });
    };
  }, []);
  const handleSubmit = (e) => {
    e.preventDefault();

    let { EPS, PayoutRation, PayoutRationWithN, g, gn, r, N } = inputParams;

    EPS = parseFloat(EPS);
    PayoutRation = parseFloat(PayoutRation) / 100;
    PayoutRationWithN = parseFloat(PayoutRationWithN) / 100;
    g = parseFloat(g) / 100;
    gn = parseFloat(gn) / 100;
    r = parseFloat(r) / 100;
    N = parseFloat(N);
    console.log(EPS, PayoutRation, PayoutRationWithN, g, gn, r, N);
    let part1 = (1 + g) ** N / (1 + r) ** N;
    let resultCalculated =
      (EPS * PayoutRation * (1 + g) * (1 - part1)) / (r - g);
    let resultCalculated2 =
      (EPS * PayoutRationWithN * (1 + g) ** N * (1 + gn)) /
      ((r - gn) * (1 + r) ** N);
    console.log(resultCalculated, resultCalculated2);
    let num2 = resultCalculated + resultCalculated2;
    let num =
      Math.round(resultCalculated * 100) / 100 +
      Math.round(resultCalculated2 * 100) / 100;
    console.log(num, num2);
    setResult(Math.round(num * 100) / 100);
    setrealResult(num2);
    notifications.showNotification({
      title: "Result calculated",
      message: "Find the result below in result display",
      color: "black",
    });
  };

  const handleToggle = (selectedValue) => {
    console.log(selectedValue);
    if (selectedValue == "PEEPS") {
      setdisableEPS(true);
      setinputParams((inputParams) => ({
        ...inputParams,
        EPS: "1",
      }));
      notifications.showNotification({
        title: "PE/EPS calculator set",
        message: "Input is disabled of EPS, it will be taken care now",
      });
    } else {
      //do nothing
      setdisableEPS(false);
      notifications.showNotification({
        title: "PE calculator set",
        message: "Input is Enabled of EPS, please enter value",
      });
    }
  };
  return (
    <div className="DataForm">
      <div className="dataform-cnt">
        <div className="input-div">
          <InputWrapper
            size="sm"
            id="input-parent"
            required
            label="EPS"
            description="Please enter EPS"
          >
            <Input
              name="EPS"
              onChange={handleValue}
              id="input-child"
              placeholder="EPS"
              type="number"
              disabled={disableEPS}
            />
          </InputWrapper>
        </div>
        <div className="input-div">
          <RadioGroup
            onChange={handleToggle}
            label="Select Which formula to calculate"
            description="Select toggle"
            required
          >
            <Radio value="PE">Calculate P</Radio>
            <Radio value="PEEPS">Calculate P / EPS</Radio>
          </RadioGroup>
        </div>
        <div className="input-div">
          <InputWrapper
            size="sm"
            id="input-parent"
            required
            label="Required Rate Of Return in Percentage"
            description="Please enter your r value"
          >
            <Input
              name="r"
              onChange={handleValue}
              id="input-child"
              placeholder="Required Rate Of Return"
              icon={<FaPercentage />}
            />
          </InputWrapper>
        </div>
        <div className="input-div">
          <InputWrapper
            size="sm"
            id="input-parent"
            required
            label="Payout Ratio"
            description="Please enter Payout ratio in Percentage  i.e High Growth Phase"
          >
            <Input
              icon={<FaPercentage />}
              name="PayoutRation"
              onChange={handleValue}
              id="input-child"
              placeholder="Payout Ratio  i.e High Growth Phase"
            />
          </InputWrapper>
        </div>
        <div className="input-div">
          <InputWrapper
            size="sm"
            id="input-parent"
            required
            label="Number of Years"
            description="Please enter N"
          >
            <Input
              name="N"
              onChange={handleValue}
              id="input-child"
              placeholder="Number of years"
            />
          </InputWrapper>
        </div>
        <div className="input-div">
          <InputWrapper
            size="sm"
            id="input-parent"
            required
            label="High growth Rate"
            description="Please enter g  in Percentage"
          >
            <Input
              name="g"
              onChange={handleValue}
              id="input-child"
              placeholder="g"
              icon={<FaPercentage />}
            />
          </InputWrapper>
        </div>
        <div className="input-div">
          <InputWrapper
            size="sm"
            id="input-parent"
            required
            label="Sustainable growth Rate"
            description="Please enter gn  in Percentage"
          >
            <Input
              name="gn"
              onChange={handleValue}
              id="input-child"
              placeholder="gn"
              icon={<FaPercentage />}
            />
          </InputWrapper>
        </div>
        <div className="input-div">
          <InputWrapper
            size="sm"
            id="input-parent"
            required
            label="PayoutRationWithN"
            description="Please enter Stable growth Phase in Percentage"
          >
            <Input
              icon={<FaPercentage />}
              name="PayoutRationWithN"
              onChange={handleValue}
              id="input-child"
              placeholder="PayoutRation With N"
            />
          </InputWrapper>
        </div>
      </div>
      <div className="form-btn">
        <Button onClick={handleSubmit} color="indigo">
          Calculate
        </Button>
        <div className="result-div">
          {" "}
          <div className="result-label">Result Rounded to 2 decimals:</div>{" "}
          <br />
          {isNaN(result)
            ? "Denominator is getting 0 , hence infinite, check values and recalculate"
            : result}
        </div>
        <div className="result-div">
          {" "}
          <div className="result-label">Result:</div> <br />
          {isNaN(realResult)
            ? "Denominator is getting 0 , hence infinite, check values and recalculate"
            : realResult}
        </div>
      </div>
    </div>
  );
}
